export const DEFAULT_CATEGORICAL_COLORS = [
    '#388AE2',
    '#33A033',
    '#672DC4',
    '#B09120',
    '#B656BD',
    '#AF155C',
    '#2644A7',
    '#AA5F18',
    '#208486',
    '#E04040',
]
